/* eslint-disable */

import Button from '@material-ui/core/Button';

import { CopyToClipboard } from "react-copy-to-clipboard";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Grid from '@material-ui/core/Grid';

import React, {useEffect} from 'react';

import { makeStyles } from '@material-ui/core/styles';
// import { PinDropSharp } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  tableRightBorder : { borderWidth: 1, borderColor: 'black',borderStyle: 'solid'},
  tableRightBorderHeader : { borderWidth: 1, borderColor: 'white',borderStyle: 'solid'} 
}));

export default function Conclusion() {
    const classes = useStyles();
    const [openCon, setOpenCon] = React.useState(false);
    const [openRep, setOpenRep] = React.useState(false);
    const [openAlert, setOpenAlert] = React.useState(false);
    const [errorMsgThyroid, setErrorMsgThyroid] = React.useState('');
    const [errorMsgCervical, setErrorMsgCervical] = React.useState('');
    const [report, setReport] = React.useState('');
    const [isCopied, setIsCopied] = React.useState(false);
    const [openDelete, setDeleteOpen] = React.useState(false);
    
    var thyroid = JSON.parse(window.localStorage.getItem("nodule"));
    var thyroidClinic = JSON.parse(window.localStorage.getItem("noduleClinic"));
    var cervical = JSON.parse(window.localStorage.getItem("node"));
    var extra = JSON.parse(window.localStorage.getItem("note"));
    var result = ''; // 결과 팝업에 들어갈 내용

    var i = 0;
    var noduleNum = {0:[], 1:[], 2:[]};
    var realNodeLength = 0;
    var nodeNum = [];

    var rightNoduleNum = []; // 몇번째 어레이 (컬럼)에 해당 노듈정보가 들어가있는지
    var leftNoduleNum = []; // 몇번째 어레이 (컬럼)에 해당 노듈정보가 들어가있는지
    var isthmusNoduleNum = []; // 몇번째 어레이 (컬럼)에 해당 노듈정보가 들어가있는지   
    var thyroidResult = [{"lobe": [], "fna": [], "cnb": [], "complication":[], "recommendation":[]},
     {"lobe": [], "fna": [], "cnb": [], "complication":[], "recommendation":[]}, 
     {"lobe": [], "fna": [], "cnb": [], "complication":[], "recommendation":[]}]; // 5번 (또는 4번 - extra에 들어간 내용이 없다면) 결과항목에 들어갈 내용
    var lymphResult = {"node": [], "fna": [], "cnb": [], "complication":[]}; // 5번 (또는 4번 - extra에 들어간 내용이 없다면) 결과항목에 들어갈 내용
    var missingValueIndex = {"thyroidLocation": [], "thyroidDiameter": [], "cervical": []}; // 필수로 넣어야 하는 값이 어디서 빠져있는지 

    // var rightNodeNum = []; // 몇번째 어레이 (컬럼)에 해당 노드정보가 들어가있는지
    // var leftNodeNum = []; // 몇번째 어레이 (컬럼)에 해당 노드정보가 들어가있는지

    var rightLobeResult = [{result:"", tirads: "", sizeCM: 0}];
    var leftLobeResult = [{result:"", tirads: "", sizeCM: 0}];
    var isthmusLobeResult = [{result:"", tirads: "", sizeCM: 0}];

    var compositionVal = "";
    var echogenicityVal = "";
    var sizeChangeVal = "";
    var orientationVal = "";
    var marginVal = "";
    var calcificationVal = "";
    var entireCalcification = {right:[""], left:[""], isthmus:[""]};
    var extrathyroidalVal = "";
    var extrathyroidalGross = [];
    var spongiform = "";
    var cometTailArtifact = "";

    var noduleI = 0;
    var nodeI = 0;     
    var numberAfter = 1; // 결과 목록에 extra에 적은 내용 없으면 해당 항목 (4번)은 건너뛰고 다음 번호(4번)로 시작하도록 하기위해
    var nextNum = 3; // starting number is 3
    
    var thyDefault = JSON.parse(window.localStorage.getItem("noduleDefault"));
    var cervicDefault = JSON.parse(window.localStorage.getItem("nodeDefault"));
    var cervicNormal = window.localStorage.getItem("nodeNormal") === 'true';

    var hasAllThyInfo = {
        0: {'location': [], 'diameter': [], 'composition': [], 'echogenicity':[], 'comment':''},
        1: {'location': [], 'diameter': [], 'composition': [], 'echogenicity':[], 'comment':''},
        2: {'location': [], 'diameter': [], 'composition': [], 'echogenicity':[], 'comment':''}
    }; //0: R, 1: L, 2: IS
    var hasAllCervicInfo = {'diameter': [], 'comment': []};
    var allThyHas = false;
    var allCervicHas = false;
    var recommendationFalg = true; // Recommendation 제목이 한번만 적혀야 하므로 두번째부터는 적히지 않도록

    useEffect(() => {
        thyroid = JSON.parse(window.localStorage.getItem("nodule"));
        thyroidClinic = JSON.parse(window.localStorage.getItem("noduleClinic"));
        cervical = JSON.parse(window.localStorage.getItem("node"));
        extra = JSON.parse(window.localStorage.getItem("note"));
    }, [openRep]);

    const onCopyText = () => {
    setIsCopied(true);
    setTimeout(() => {
        setIsCopied(false);
    }, 1000);
    alert('Copied to Clipboard');
    };

    const handleClickCloseDialog = () => {
        if(openAlert) setOpenAlert(false);
        else setOpenCon(false);
    }

    function getLocation(type, i){
        var val = ' ';
        if(thyroid[type].data[i].location.position === 'upper') { if(val.length > 0)  val += 'Upper, '; }
        if(thyroid[type].data[i].location.position === 'middle') { if(val.length > 0)  val += 'Middle, '; }
        if(thyroid[type].data[i].location.position === 'lower') { if(val.length > 0) val += ' Lower, '; }
        // if(thyroid[type].data[i].location.type.substring(0,1) === 'R') { if(val.length > 0) val += 'Right, '; }
        // if(thyroid[type].data[i].location.type.substring(0,1) === 'L') { if(val.length > 0) val += 'Left, '; }
        // if(thyroid[type].data[i].location.type.substring(0,1) === 'I') { if(val.length > 0) val += 'Isthums, '; }
        return val;
    }

    function A_i(type, i){
        if(thyroid[type].data[i].calcification.micro === true
            || thyroid[type].data[i].orientation === 'Nonparallel'
            || thyroid[type].data[i].margin === 'Irregular (spiculated/microlobulated)')
            return true;
        return false;
    }

    function checkHighsuspicion(type, i){
        if(A_i(type, i) && thyroid[type].data[i].composition === 'Solid' && (thyroid[type].data[i].echogenicity === 'Mild hypo' || thyroid[type].data[i].echogenicity === 'Marked hypo')) //|| thyroid[type].data[i].echogenicity === 'Hyper'))
            return true;
        return false;
    }

    function checkIntermediateSuspicion(type, i){
        if(thyroid[type].data[i].composition === 'Solid' 
            && A_i(type, i)===false 
            && (thyroid[type].data[i].echogenicity === 'Mild hypo' || thyroid[type].data[i].echogenicity === 'Marked hypo'))
            return true;
        if((thyroid[type].data[i].composition === 'P.Cystic' || thyroid[type].data[i].composition === 'P.Solid')
            && A_i(type, i)===true)
            return true;
        if((thyroid[type].data[i].echogenicity === 'Iso' || thyroid[type].data[i].echogenicity === 'Hyper')
            && A_i(type, i)===true)
            return true;
        if(thyroid[type].data[i].diffuseLesion === 'extensive' || thyroid[type].data[i].diffuseLesion === 'infiltrative')
            return true;
        if(thyroid[type].data[i].calcification.entire) return true;
            
        return false; 
    }

    function checkLowSuspicion(type, i){
        if((thyroid[type].data[i].composition === 'P.Cystic' || thyroid[type].data[i].composition === 'P.Solid')
            && A_i(type, i)===false)
            return true;        
        if((thyroid[type].data[i].echogenicity === 'Iso' || thyroid[type].data[i].echogenicity === 'Hyper')
            && A_i(type, i)===false)
            return true;
        return false; 
    }

    function checkBenign3under(type, i){
        if(thyroid[type].data[i].spongiform === 'Yes') return true;
        return false; 
    }

    function checkBenign1under(type, i){
        if((thyroid[type].data[i].composition === 'P.Cystic' || thyroid[type].data[i].composition === 'P.Solid')
            && thyroid[type].data[i].cometTailArtifact === 'Yes')
            return true;
        if(thyroid[type].data[i].composition === 'Cystic')
            return true;
        if(thyroid[type].data[i].spongiform === 'Yes')
            return true;
        return false;
    }

    function getRiskOfMalignancy(type, i){
        var risk = '';        
        
        if(!thyroidClinic.normalThy){
            if(checkHighsuspicion(type, i)) return '[K-TIRADS 5, High suspicion]'; // A
            if(checkIntermediateSuspicion(type, i)) return '[K-TIRADS 4, Intermediate suspicion]'; // B
            // requested by client, check D & E first before C 
            if(checkBenign3under(type, i)) return '[K-TIRADS 2, Benign]'; // D
            if(checkBenign1under(type, i)) return '[K-TIRADS 2, Benign]'; // E
            if(checkLowSuspicion(type, i)) return '[K-TIRADS 3, Low suspicion]'; // C
        }
        // console.log(risk);
        return risk;
    }

    const getConclusion =() => {
        result = 'Clinical information: ' + thyroidClinic.clinicalInformation;
        // if(thyroidClinic.historyDate[0] !== '' || thyroidClinic.historyDate[1] !== '' || thyroidClinic.historyDate[2] !== '')
        //     result += '<br/>Compared with previous study: US (' + thyroidClinic.historyDate[0] + '/' + thyroidClinic.historyDate[1] + '/' + thyroidClinic.historyDate[2] + ')';
        // else
        //     result += '<br/>Compared with previous study: not available';

        if(thyroidClinic.usDate[0] !== '' || thyroidClinic.usDate[1] !== '' || thyroidClinic.usDate[2] !== '')
            result += '<br/>Comparison: US (' + thyroidClinic.usDate[0] + '/' + thyroidClinic.usDate[1] + '/' + thyroidClinic.usDate[2] + ')';
        else
            result += '<br/>Comparison: not available';
            

        if(thyroidClinic.normalThy) {
            result += "<br/><br/>Findings:<br/>1. Thyroid parenchyma <br/>Normal size, echogenicity, and vascularity.<br/>2. Thyroid nodule<br/>No focal lesion in both thyroid lobes and isthmus.";
        }
        else
        {
            if(!thyroidClinic.diffusionThyroidDisease && !thyroidClinic.multinodule){     
                result += '<br/><br/>Findings:<br/>1. Thyroid parenchyma <br/>Diffuse thyroid disease: Absence<br/>2. Thyroid nodule<br/>';
            }
            else if (thyroidClinic.diffusionThyroidDisease && thyroidClinic.multinodule){     
                result += '<br/><br/>Findings:<br/>1. Thyroid parenchyma <br/>Diffuse thyroid disease with multinodular goiter.<br/>2. Thyroid nodule<br/>';
            }
            else if (thyroidClinic.diffusionThyroidDisease  && !thyroidClinic.multinodule) {
                result += '<br/><br/>Findings:<br/>1. Thyroid parenchyma <br/>Diffuse thyroid disease: Presence<br/>2. Thyroid nodule<br/>'
            }
            else if (thyroidClinic.multinodule){
                result += "<br/><br/>Findings:<br/>1. Thyroid parenchyma <br/>Multinodular goiter<br/>2. Thyroid nodule<br/>"
            }
        }

        for (var dl = 0; dl < thyroid.length; dl++){
            for (var nl = 0; nl < noduleNum[dl].length; nl++){
                if(thyroid[dl].data[noduleNum[dl][nl]].biopsy.type === 'FNA') thyroidResult[dl].fna[noduleNum[dl][nl]] = 'FNA, '; else thyroidResult[dl].fna[noduleNum[dl][nl]] = ''
                if(thyroid[dl].data[noduleNum[dl][nl]].biopsy.type === 'CNB') thyroidResult[dl].cnb[noduleNum[dl][nl]] = 'CNB, '; else thyroidResult[dl].cnb[noduleNum[dl][nl]] = ''
                if(thyroid[dl].data[noduleNum[dl][nl]].complications.yes) thyroidResult[dl].complication[noduleNum[dl][nl]] = 'complication';
                if(thyroid[dl].data[noduleNum[dl][nl]].complications.intrathyroidal && thyroid[dl].data[noduleNum[dl][nl]].complications.perithyroidal) {
                    if(thyroid[dl].data[noduleNum[dl][nl]].complications.others) {
                        if(thyroid[dl].data[noduleNum[dl][nl]].complications.othersTxt) thyroidResult[dl].complication[noduleNum[dl][nl]] += ' (' + thyroid[dl].data[noduleNum[dl][nl]].complications.othersTxt + ')';
                    }
                    else {
                        if(thyroid[dl].data[noduleNum[dl][nl]].complications.intrathyroidal)
                            thyroidResult[dl].complication[noduleNum[dl][nl]] += ' (' + thyroid[dl].data[noduleNum[dl][nl]].complications.intrathyroidal + ')';
                        else if (thyroid[dl].data[noduleNum[dl][nl]].complications.perithyroidal)
                            thyroidResult[dl].complication[noduleNum[dl][nl]] += ' (' + thyroid[dl].data[noduleNum[dl][nl]].complications.perithyroidal + ')';
                        else
                            thyroidResult[dl].complication[noduleNum[dl][nl]] += ' (' + thyroid[dl].data[noduleNum[dl][nl]].complications.intrathyroidal + ', ' + thyroid[dl].data[noduleNum[dl][nl]].complications.perithyroidal + ')';   
                    }
                }
                else thyroidResult[dl].complication[noduleNum[dl][nl]] = 'no complication';
                if(thyroid[dl].data[noduleNum[dl][nl]].recommendation !== '') thyroidResult[dl].recommendation[noduleNum[dl][nl]] = thyroid[dl].data[noduleNum[dl][nl]].recommendation;
            }
        }

        var nextNoduleNumb = 1;
        var fnaBiopsyNodule = [];
        var cnbBiopsyNodule = [];
        var thyroidComment = [];
        var cervicalComment = [];
        var thyroidRecommendation = [];
        var suspiciousRightNodeNum = [];
        var suspiciousLeftNodeNum = [];
        var indeterminateRightNodeNum = [];
        var indeterminateLefttNodeNum = [];
        var cervicalFnaBiopsyNodule = [];
        var cervicalCnbBiopsyNodule = [];
        var biopsyFnaFlag = true;
        var biopsyCnbFlag = true;

        if (rightNoduleNum.length !== 0){
            result += '1) Right lobe<br/>';
            nextNoduleNumb += 1;

            for (var rightN = 0; rightN < rightNoduleNum.length; rightN++){
                if(thyroid[0].key === 'R'){
                    thyroidResult[0].lobe[rightNoduleNum[rightN]] = '';
                    thyroidResult[0].lobe[rightNoduleNum[rightN]] += 'R' + (rightNoduleNum[rightN] + 1);
                    // reset the values
                    compositionVal = "";
                    echogenicityVal = "";
                    sizeChangeVal = "";
                    orientationVal = "";
                    marginVal = "";
                    calcificationVal = "";
                    extrathyroidalVal = "";
                    extrathyroidalGross = [];
                    spongiform = "";
                    cometTailArtifact = "";
                    ///
    
                    if (thyroid[0].data[rightNoduleNum[rightN]].composition === "Solid") compositionVal = ", Solid";
                    if (thyroid[0].data[rightNoduleNum[rightN]].composition === "P.Solid") compositionVal = ", P.Solid";
                    if (thyroid[0].data[rightNoduleNum[rightN]].composition === "P.Cystic") compositionVal = ", P.Cystic";
                    if (thyroid[0].data[rightNoduleNum[rightN]].composition === "Cystic") compositionVal = ", Cystic";
    
                    if (thyroid[0].data[rightNoduleNum[rightN]].echogenicity === "Marked hypo") echogenicityVal = ", Marked hypo";
                    if (thyroid[0].data[rightNoduleNum[rightN]].echogenicity === "Mild hypo") echogenicityVal = ", Mild hypo";
                    if (thyroid[0].data[rightNoduleNum[rightN]].echogenicity === "Iso") echogenicityVal = ", Iso";
                    if (thyroid[0].data[rightNoduleNum[rightN]].echogenicity === "Hyper") echogenicityVal = ", Hyper";
    
                    if (thyroid[0].data[rightNoduleNum[rightN]].changeInSize.value === "Initial, follow-up") sizeChangeVal = ", Initial, follow-up";
                    if (thyroid[0].data[rightNoduleNum[rightN]].changeInSize.value === "New") sizeChangeVal = ", New";
                    if (thyroid[0].data[rightNoduleNum[rightN]].changeInSize.value === "Increased") sizeChangeVal = ", Increased";
                    if (thyroid[0].data[rightNoduleNum[rightN]].changeInSize.value === "Decreased") sizeChangeVal = ", Decreased";
                    if (thyroid[0].data[rightNoduleNum[rightN]].changeInSize.value === "Stable") sizeChangeVal = ", Stable";
                    
                    if (thyroid[0].data[rightNoduleNum[rightN]].orientation === "Nonparallel") orientationVal = ", Nonparallel";
                    if (thyroid[0].data[rightNoduleNum[rightN]].margin === "Irregular (spiculated/microlobulated)") marginVal = ", irregular";
                    if (thyroid[0].data[rightNoduleNum[rightN]].calcification.micro) calcificationVal = ", PEF";
                    if (thyroid[0].data[rightNoduleNum[rightN]].calcification.entire === "entire") entireCalcification.right[rightN] = ", Entired calcified nodule";
                    else entireCalcification.right[rightN] = "";
                    if (thyroid[0].data[rightNoduleNum[rightN]].spongiform === "Yes") spongiform = ", Spongiform";
                    if (thyroid[0].data[rightNoduleNum[rightN]].cometTailArtifact === "Yes") cometTailArtifact = ", Intracystic echogenic foci with comet tail artifact";
                    if (thyroid[0].data[rightNoduleNum[rightN]].extrathyroidal) extrathyroidalVal = ", " + thyroid[0].data[rightNoduleNum[rightN]].extrathyroidal;
                    if (thyroid[0].data[rightNoduleNum[rightN]].extrathyroidalLocation.ant && thyroid[0].data[rightNoduleNum[rightN]].extrathyroidalLocation.post) extrathyroidalVal += ' (ant, post)';
                    else if (thyroid[0].data[rightNoduleNum[rightN]].extrathyroidalLocation.ant) extrathyroidalVal += ' (ant)';
                    else if (thyroid[0].data[rightNoduleNum[rightN]].extrathyroidalLocation.post) extrathyroidalVal += ' (post)';
                    if (thyroid[0].data[rightNoduleNum[rightN]].extrathyroidal2) extrathyroidalVal += ", " + thyroid[0].data[rightNoduleNum[rightN]].extrathyroidal2;
                    if (thyroid[0].data[rightNoduleNum[rightN]].extrathyroidalGross.trachea) extrathyroidalGross.push("trachea");
                    if (thyroid[0].data[rightNoduleNum[rightN]].extrathyroidalGross.RLN) extrathyroidalGross.push("RLN");
                    if (thyroid[0].data[rightNoduleNum[rightN]].extrathyroidalGross.strap) extrathyroidalGross.push("strap muscle");
                    if (thyroid[0].data[rightNoduleNum[rightN]].extrathyroidalGross.input) extrathyroidalGross.push(thyroid[0].data[rightNoduleNum[rightN]].extrathyroidalGross.input);
                    if (thyroid[0].data[rightNoduleNum[rightN]].biopsy && thyroid[0].data[rightNoduleNum[rightN]].biopsy.type === 'FNA') fnaBiopsyNodule.push('R' + Number(rightN+1));
                    if (thyroid[0].data[rightNoduleNum[rightN]].biopsy && thyroid[0].data[rightNoduleNum[rightN]].biopsy.type === 'FNA' && thyroid[0].data[rightNoduleNum[rightN]].complications.no) fnaBiopsyNodule.push('no complication');
                    if (thyroid[0].data[rightNoduleNum[rightN]].biopsy && thyroid[0].data[rightNoduleNum[rightN]].biopsy.type === 'FNA' && thyroid[0].data[rightNoduleNum[rightN]].complications.intrathyroidal) fnaBiopsyNodule.push('Intrathyroidal hematoma');
                    if (thyroid[0].data[rightNoduleNum[rightN]].biopsy && thyroid[0].data[rightNoduleNum[rightN]].biopsy.type === 'FNA' && thyroid[0].data[rightNoduleNum[rightN]].complications.perithyroidal) fnaBiopsyNodule.push('Perithyroidal hematoma');
                    if (thyroid[0].data[rightNoduleNum[rightN]].biopsy && thyroid[0].data[rightNoduleNum[rightN]].biopsy.type === 'FNA' && thyroid[0].data[rightNoduleNum[rightN]].complications.othersTxt) fnaBiopsyNodule.push(thyroid[0].data[rightNoduleNum[rightN]].complications.othersTxt);
                    if (thyroid[0].data[rightNoduleNum[rightN]].biopsy && thyroid[0].data[rightNoduleNum[rightN]].biopsy.type === 'CNB') cnbBiopsyNodule.push('R' + Number(rightN+1));
                    if (thyroid[0].data[rightNoduleNum[rightN]].biopsy && thyroid[0].data[rightNoduleNum[rightN]].biopsy.type === 'CNB' && thyroid[0].data[rightNoduleNum[rightN]].complications.no) cnbBiopsyNodule.push('no complication');
                    if (thyroid[0].data[rightNoduleNum[rightN]].biopsy && thyroid[0].data[rightNoduleNum[rightN]].biopsy.type === 'CNB' && thyroid[0].data[rightNoduleNum[rightN]].complications.intrathyroidal) cnbBiopsyNodule.push('Intrathyroidal hematoma');
                    if (thyroid[0].data[rightNoduleNum[rightN]].biopsy && thyroid[0].data[rightNoduleNum[rightN]].biopsy.type === 'CNB' && thyroid[0].data[rightNoduleNum[rightN]].complications.perithyroidal) cnbBiopsyNodule.push('Perithyroidal hematoma');
                    if (thyroid[0].data[rightNoduleNum[rightN]].biopsy && thyroid[0].data[rightNoduleNum[rightN]].biopsy.type === 'CNB' && thyroid[0].data[rightNoduleNum[rightN]].complications.othersTxt) cnbBiopsyNodule.push('others(' + thyroid[0].data[rightNoduleNum[rightN]].complications.othersTxt + ')');
                    if (thyroid[0].data[rightNoduleNum[rightN]].comment.length > 0 ) thyroidComment.push(thyroid[0].data[rightNoduleNum[rightN]].comment);
                    if (thyroid[0].data[rightNoduleNum[rightN]].note.length > 0 ) thyroidRecommendation.push(thyroid[0].data[rightNoduleNum[rightN]].note);

                    if(thyroid[0].data[rightNoduleNum[rightN]].diameter[3]) {
                        rightLobeResult[rightN] = {result:(thyroidResult[0].lobe[rightNoduleNum[rightN]] + ', ' + thyroid[0].data[rightNoduleNum[rightN]].location.position + ', ' + thyroid[0].data[rightNoduleNum[rightN]].diameter[3] + thyroid[0].data[rightNoduleNum[rightN]].diameter[5] + entireCalcification.right[rightN] + sizeChangeVal + ' ' + getRiskOfMalignancy(0, rightNoduleNum[rightN])), tirads: getRiskOfMalignancy(0, rightNoduleNum[rightN]), sizeCM:thyroid[0].data[rightNoduleNum[rightN]].diameter[3]};
                        rightLobeResult[rightN].result = rightLobeResult[rightN].result.replace(/,\s*$/, "");

                        if (orientationVal || marginVal || calcificationVal) {
                            if(rightN > 0) result += "<br/>";
                            result += thyroidResult[0].lobe[rightNoduleNum[rightN]] + ':' + getLocation(0, rightNoduleNum[rightN]) + thyroid[0].data[rightNoduleNum[rightN]].diameter[3] + thyroid[0].data[rightNoduleNum[rightN]].diameter[5] + compositionVal + echogenicityVal + orientationVal + marginVal + calcificationVal + spongiform + cometTailArtifact + entireCalcification.right[rightN] + sizeChangeVal + extrathyroidalVal;
                        }
                        else{
                            if(rightN > 0) result += "<br/>";
                            result += thyroidResult[0].lobe[rightNoduleNum[rightN]] + ':' + getLocation(0, rightNoduleNum[rightN]) + thyroid[0].data[rightNoduleNum[rightN]].diameter[3] + thyroid[0].data[rightNoduleNum[rightN]].diameter[5] + compositionVal + echogenicityVal + spongiform + cometTailArtifact + entireCalcification.right[rightN] + sizeChangeVal + extrathyroidalVal;
                        }
                        result = result.replace(/,\s*$/, "");
                        // if(entireCalcification.right[rightN]) result += entireCalcification.right[rightN];
                        if (extrathyroidalGross.length > 0) result += " (" + extrathyroidalGross.toString().split(',').join(", ") + ")";
                        result += ' ' + getRiskOfMalignancy(0, rightNoduleNum[rightN]);
    
                        if(thyroid[0].data[rightNoduleNum[rightN]].comment.length > 0) result += "<br/>" + thyroid[0].data[rightNoduleNum[rightN]].comment + ", right.";
                    }
                    else {if(thyroid[0].data[rightNoduleNum[rightN]].comment.length > 0) result += thyroid[0].data[rightNoduleNum[rightN]].comment + ", right.";}
                }
            }
        } 
        else{
            if(!thyroidClinic.normalThy) result += '1) Right lobe<br/>No focal lesion'; 
        }

        if (leftNoduleNum.length != 0){
            result += '<br/>2) Left lobe <br/>';
            nextNoduleNumb += 1;

            for (var leftN = 0; leftN < leftNoduleNum.length; leftN++){
                if(thyroid[1].key === 'L'){
                    thyroidResult[0].lobe[rightNoduleNum[rightN]] = '';
                    if(leftN > 0) thyroidResult[1].lobe[leftNoduleNum[leftN]] = "<br/>";
                    thyroidResult[1].lobe[leftNoduleNum[leftN]] = 'L' + (leftNoduleNum[leftN] + 1);
                    // reset the values
                    compositionVal = "";
                    echogenicityVal = "";
                    sizeChangeVal = "";
                    orientationVal = "";
                    marginVal = "";
                    calcificationVal = "";
                    extrathyroidalVal = "";
                    extrathyroidalGross = [];
                    spongiform = "";
                    cometTailArtifact = "";
                    ///
    
                    if (thyroid[1].data[leftNoduleNum[leftN]].composition === "Solid") compositionVal = ", Solid";
                    if (thyroid[1].data[leftNoduleNum[leftN]].composition === "P.Solid") compositionVal = ", P.Solid";
                    if (thyroid[1].data[leftNoduleNum[leftN]].composition === "P.Cystic") compositionVal = ", P.Cystic";
                    if (thyroid[1].data[leftNoduleNum[leftN]].composition === "Cystic") compositionVal = ", Cystic";
    
                    if (thyroid[1].data[leftNoduleNum[leftN]].echogenicity === "Marked hypo") echogenicityVal = ", Marked hypo";
                    if (thyroid[1].data[leftNoduleNum[leftN]].echogenicity === "Mild hypo") echogenicityVal = ", Mild hypo";
                    if (thyroid[1].data[leftNoduleNum[leftN]].echogenicity === "Iso") echogenicityVal = ", Iso";
                    if (thyroid[1].data[leftNoduleNum[leftN]].echogenicity === "Hyper") echogenicityVal = ", Hyper";
    
                    if (thyroid[1].data[leftNoduleNum[leftN]].changeInSize.value === "Initial, follow-up") sizeChangeVal = ", Initial, follow-up";
                    if (thyroid[1].data[leftNoduleNum[leftN]].changeInSize.value === "New") sizeChangeVal = ", New";
                    if (thyroid[1].data[leftNoduleNum[leftN]].changeInSize.value === "Increased") sizeChangeVal = ", Increased";
                    if (thyroid[1].data[leftNoduleNum[leftN]].changeInSize.value === "Decreased") sizeChangeVal = ", Decreased";
                    if (thyroid[1].data[leftNoduleNum[leftN]].changeInSize.value === "Stable") sizeChangeVal = ", Stable";
    
                    if (thyroid[1].data[leftNoduleNum[leftN]].orientation === "Nonparallel") orientationVal = ", Nonparallel";
                    if (thyroid[1].data[leftNoduleNum[leftN]].margin === "Irregular (spiculated/microlobulated)") marginVal = ", irregular";
                    if (thyroid[1].data[leftNoduleNum[leftN]].calcification.micro) calcificationVal = ", PEF";
                    if (thyroid[1].data[leftNoduleNum[leftN]].calcification.entire === "entire") entireCalcification.left[leftN] = ", Entired calcified nodule";
                    else entireCalcification.left[leftN] = "";
                    if (thyroid[1].data[leftNoduleNum[leftN]].spongiform === "Yes") spongiform = ", Spongiform";
                    if (thyroid[1].data[leftNoduleNum[leftN]].cometTailArtifact === "Yes") cometTailArtifact = ", Intracystic echogenic foci with comet tail artifact";
                    if (thyroid[1].data[leftNoduleNum[leftN]].extrathyroidal) extrathyroidalVal = ", " + thyroid[1].data[leftNoduleNum[leftN]].extrathyroidal;
                    if (thyroid[1].data[leftNoduleNum[leftN]].extrathyroidalLocation.ant && thyroid[1].data[leftNoduleNum[leftN]].extrathyroidalLocation.post) extrathyroidalVal += ' (ant, post)';
                    else if (thyroid[1].data[leftNoduleNum[leftN]].extrathyroidalLocation.ant) extrathyroidalVal += ' (ant)';
                    else if (thyroid[1].data[leftNoduleNum[leftN]].extrathyroidalLocation.post) extrathyroidalVal += ' (post)';
                    if (thyroid[1].data[leftNoduleNum[leftN]].extrathyroidal2) extrathyroidalVal += ", " + thyroid[1].data[leftNoduleNum[leftN]].extrathyroidal2;
                    if (thyroid[1].data[leftNoduleNum[leftN]].extrathyroidalGross.trachea) extrathyroidalGross.push("trachea");
                    if (thyroid[1].data[leftNoduleNum[leftN]].extrathyroidalGross.RLN) extrathyroidalGross.push("RLN");
                    if (thyroid[1].data[leftNoduleNum[leftN]].extrathyroidalGross.strap) extrathyroidalGross.push("strap muscle");
                    if (thyroid[1].data[leftNoduleNum[leftN]].extrathyroidalGross.input) extrathyroidalGross.push(thyroid[1].data[leftNoduleNum[leftN]].extrathyroidalGross.input);
                    if (thyroid[1].data[leftNoduleNum[leftN]].biopsy && thyroid[1].data[leftNoduleNum[leftN]].biopsy.type === 'FNA') fnaBiopsyNodule.push('L' + Number(leftN+1));
                    if (thyroid[1].data[leftNoduleNum[leftN]].biopsy && thyroid[1].data[leftNoduleNum[leftN]].biopsy.type === 'FNA' && thyroid[1].data[leftNoduleNum[leftN]].complications.no) fnaBiopsyNodule.push('no complication');
                    if (thyroid[1].data[leftNoduleNum[leftN]].biopsy && thyroid[1].data[leftNoduleNum[leftN]].biopsy.type === 'FNA' && thyroid[1].data[leftNoduleNum[leftN]].complications.intrathyroidal) fnaBiopsyNodule.push('Intrathyroidal hematoma');
                    if (thyroid[1].data[leftNoduleNum[leftN]].biopsy && thyroid[1].data[leftNoduleNum[leftN]].biopsy.type === 'FNA' && thyroid[1].data[leftNoduleNum[leftN]].complications.perithyroidal) fnaBiopsyNodule.push('Perithyroidal hematoma');
                    if (thyroid[1].data[leftNoduleNum[leftN]].biopsy && thyroid[1].data[leftNoduleNum[leftN]].biopsy.type === 'FNA'&& thyroid[1].data[leftNoduleNum[leftN]].complications.othersTxt) fnaBiopsyNodule.push(thyroid[1].data[leftNoduleNum[leftN]].complications.othersTxt);
                    if (thyroid[1].data[leftNoduleNum[leftN]].biopsy && thyroid[1].data[leftNoduleNum[leftN]].biopsy.type === 'CNB') cnbBiopsyNodule.push('L' + Number(leftN+1));
                    if (thyroid[1].data[leftNoduleNum[leftN]].biopsy && thyroid[1].data[leftNoduleNum[leftN]].biopsy.type === 'CNB' && thyroid[1].data[leftNoduleNum[leftN]].complications.no) cnbBiopsyNodule.push('no complication');
                    if (thyroid[1].data[leftNoduleNum[leftN]].biopsy && thyroid[1].data[leftNoduleNum[leftN]].biopsy.type === 'CNB' && thyroid[1].data[leftNoduleNum[leftN]].complications.intrathyroidal) cnbBiopsyNodule.push('Intrathyroidal hematoma');
                    if (thyroid[1].data[leftNoduleNum[leftN]].biopsy && thyroid[1].data[leftNoduleNum[leftN]].biopsy.type === 'CNB' && thyroid[1].data[leftNoduleNum[leftN]].complications.perithyroidal) cnbBiopsyNodule.push('Perithyroidal hematoma');
                    if (thyroid[1].data[leftNoduleNum[leftN]].biopsy && thyroid[1].data[leftNoduleNum[leftN]].biopsy.type === 'CNB'&& thyroid[1].data[leftNoduleNum[leftN]].complications.othersTxt) cnbBiopsyNodule.push('others(' + thyroid[1].data[leftNoduleNum[leftN]].complications.othersTxt + ')');
                    if (thyroid[1].data[leftNoduleNum[leftN]].comment.length > 0 ) thyroidComment.push(thyroid[1].data[leftNoduleNum[leftN]].comment);
                    if (thyroid[1].data[leftNoduleNum[leftN]].note.length > 0 ) thyroidRecommendation.push(thyroid[1].data[leftNoduleNum[leftN]].note);

                    if(thyroid[1].data[leftNoduleNum[leftN]].diameter[3]) {
                        leftLobeResult[leftN] = {result:(thyroidResult[1].lobe[leftNoduleNum[leftN]] + ', ' + thyroid[1].data[leftNoduleNum[leftN]].location.position + ', ' + thyroid[1].data[leftNoduleNum[leftN]].diameter[3] + thyroid[1].data[leftNoduleNum[leftN]].diameter[5] + entireCalcification.left[leftN] + sizeChangeVal + ' ' + getRiskOfMalignancy(1, leftNoduleNum[leftN])), tirads: getRiskOfMalignancy(1, leftNoduleNum[leftN]), sizeCM:thyroid[1].data[leftNoduleNum[leftN]].diameter[3]};
                        leftLobeResult[leftN].result = leftLobeResult[leftN].result.replace(/,\s*$/, "");

                        if (orientationVal || marginVal || calcificationVal) {
                            if(leftN > 0) result += "<br/>";
                            result += thyroidResult[1].lobe[leftNoduleNum[leftN]] +  ':' + getLocation(1, leftNoduleNum[leftN]) + thyroid[1].data[leftNoduleNum[leftN]].diameter[3] + thyroid[1].data[leftNoduleNum[leftN]].diameter[5] + compositionVal + echogenicityVal  + orientationVal + marginVal + calcificationVal + spongiform + cometTailArtifact + entireCalcification.left[leftN] + sizeChangeVal + extrathyroidalVal;
                        }
                        else{
                            if(leftN > 0) result += "<br/>";
                            result += thyroidResult[1].lobe[leftNoduleNum[leftN]] + ':' + getLocation(1, leftNoduleNum[leftN]) + thyroid[1].data[leftNoduleNum[leftN]].diameter[3] + thyroid[1].data[leftNoduleNum[leftN]].diameter[5] + compositionVal + echogenicityVal + spongiform + cometTailArtifact + entireCalcification.left[leftN] + sizeChangeVal + extrathyroidalVal;
                        }
                        result = result.replace(/,\s*$/, "");
                        // if(entireCalcification.left[leftN]) result += entireCalcification.left[leftN];
                        if (extrathyroidalGross.length > 0)  result += " (" + extrathyroidalGross.toString().split(',').join(", ") + ")";
                        result += " " + getRiskOfMalignancy(1, leftNoduleNum[leftN]);
    
                        if(thyroid[1].data[leftNoduleNum[leftN]].comment.length > 0) result += "<br/>" + thyroid[1].data[leftNoduleNum[leftN]].comment + ", left.";
                    }
                    else {if(thyroid[1].data[leftNoduleNum[leftN]].comment.length > 0) result += thyroid[1].data[leftNoduleNum[leftN]].comment + ", left.";}
                }
            }
        }
        else{
            if(!thyroidClinic.normalThy) result += '<br/>2) Left lobe<br/>No focal lesion'; 
        }

        if (isthmusNoduleNum.length != 0) {//|| isthmusN != isthmusNoduleNum.length-1) {
            result += '<br/>3) Isthmus <br/>';
            nextNoduleNumb += 1;

            for (var isthmusN = 0; isthmusN < isthmusNoduleNum.length; isthmusN++){
                if(thyroid[2].key === 'IS'){
                    thyroidResult[2].lobe[isthmusNoduleNum[isthmusN]] = '';
                    if(isthmusN > 0) thyroidResult[2].lobe[isthmusNoduleNum[isthmusN]] = "<br/>";
                    thyroidResult[2].lobe[isthmusNoduleNum[isthmusN]] = 'IS' + (isthmusNoduleNum[isthmusN] + 1);
                    // reset the values
                    compositionVal = "";
                    echogenicityVal = "";
                    sizeChangeVal = "";
                    orientationVal = "";
                    marginVal = "";
                    calcificationVal = "";
                    extrathyroidalVal = "";
                    extrathyroidalGross = [];
                    spongiform = "";
                    cometTailArtifact = "";
                    ///
    
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].composition === "Solid") compositionVal = ", Solid";
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].composition === "P.Solid") compositionVal = ", P.Solid";
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].composition === "P.Cystic") compositionVal = ", P.Cystic";
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].composition === "Cystic") compositionVal = ", Cystic";
    
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].echogenicity === "Marked hypo") echogenicityVal = ", Marked hypo";
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].echogenicity === "Mild hypo") echogenicityVal = ", Mild hypo";
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].echogenicity === "Iso") echogenicityVal = ", Iso";
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].echogenicity === "Hyper") echogenicityVal = ", Hyper";
    
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].changeInSize.value === "Initial, follow-up") sizeChangeVal = ", Initial, follow-up";
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].changeInSize.value === "New") sizeChangeVal = ", New";
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].changeInSize.value === "Increased") sizeChangeVal = ", Increased";
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].changeInSize.value === "Decreased") sizeChangeVal = ", Decreased";
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].changeInSize.value === "Stable") sizeChangeVal = ", Stable";
                    
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].orientation === "Nonparallel") orientationVal = ", Nonparallel";
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].margin === "Irregular (spiculated/microlobulated)") marginVal = ", irregular";
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].calcification.micro) calcificationVal = ", PEF";
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].calcification.entire === "entire") entireCalcification.isthmus[isthmusN] = ", Entired calcified nodule";
                    else entireCalcification.isthmus[isthmusN] = "";
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].spongiform === "Yes") spongiform = ", Spongiform";
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].cometTailArtifact === "Yes") cometTailArtifact = ", Intracystic echogenic foci with comet tail artifact";
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].extrathyroidal) extrathyroidalVal = ", " + thyroid[2].data[isthmusNoduleNum[isthmusN]].extrathyroidal;
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].extrathyroidalLocation.ant && thyroid[2].data[isthmusNoduleNum[isthmusN]].extrathyroidalLocation.post) extrathyroidalVal += ' (ant, post)';
                    else if (thyroid[2].data[isthmusNoduleNum[isthmusN]].extrathyroidalLocation.ant) extrathyroidalVal += ' (ant)';
                    else if (thyroid[2].data[isthmusNoduleNum[isthmusN]].extrathyroidalLocation.post) extrathyroidalVal += ' (post)';
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].extrathyroidal2) extrathyroidalVal += ", " + thyroid[2].data[isthmusNoduleNum[isthmusN]].extrathyroidal2;
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].extrathyroidalGross.trachea) extrathyroidalGross.push("trachea");
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].extrathyroidalGross.RLN) extrathyroidalGross.push("RLN");
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].extrathyroidalGross.strap) extrathyroidalGross.push("strap muscle");
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].extrathyroidalGross.input) extrathyroidalGross.push(thyroid[2].data[isthmusNoduleNum[isthmusN]].extrathyroidalGross.input);
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].biopsy && thyroid[2].data[isthmusNoduleNum[isthmusN]].biopsy.type === 'FNA') fnaBiopsyNodule.push('IS' + Number(isthmusN+1));
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].biopsy && thyroid[2].data[isthmusNoduleNum[isthmusN]].biopsy.type === 'FNA' && thyroid[2].data[isthmusNoduleNum[isthmusN]].complications.no) fnaBiopsyNodule.push('no complication');
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].biopsy && thyroid[2].data[isthmusNoduleNum[isthmusN]].biopsy.type === 'FNA' && thyroid[2].data[isthmusNoduleNum[isthmusN]].complications.intrathyroidal) fnaBiopsyNodule.push('Intrathyroidal hematoma');
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].biopsy && thyroid[2].data[isthmusNoduleNum[isthmusN]].biopsy.type === 'FNA' && thyroid[2].data[isthmusNoduleNum[isthmusN]].complications.perithyroidal) fnaBiopsyNodule.push('Perithyroidal hematoma');
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].biopsy && thyroid[2].data[isthmusNoduleNum[isthmusN]].biopsy.type === 'FNA' && thyroid[2].data[isthmusNoduleNum[isthmusN]].complications.othersTxt) fnaBiopsyNodule.push(thyroid[2].data[isthmusNoduleNum[isthmusN]].complications.othersTxt);
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].biopsy && thyroid[2].data[isthmusNoduleNum[isthmusN]].biopsy.type === 'CNB') cnbBiopsyNodule.push('IS' + Number(isthmusN+1));
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].biopsy && thyroid[2].data[isthmusNoduleNum[isthmusN]].biopsy.type === 'CNB' && thyroid[2].data[isthmusNoduleNum[isthmusN]].complications.no) cnbBiopsyNodule.push('no complication');
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].biopsy && thyroid[2].data[isthmusNoduleNum[isthmusN]].biopsy.type === 'CNB' && thyroid[2].data[isthmusNoduleNum[isthmusN]].complications.intrathyroidal) cnbBiopsyNodule.push('Intrathyroidal hematoma');
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].biopsy && thyroid[2].data[isthmusNoduleNum[isthmusN]].biopsy.type === 'CNB' && thyroid[2].data[isthmusNoduleNum[isthmusN]].complications.perithyroidal) cnbBiopsyNodule.push('Perithyroidal hematoma');
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].biopsy && thyroid[2].data[isthmusNoduleNum[isthmusN]].biopsy.type === 'CNB' && thyroid[2].data[isthmusNoduleNum[isthmusN]].complications.othersTxt) cnbBiopsyNodule.push('others(' + thyroid[2].data[isthmusNoduleNum[isthmusN]].complications.othersTxt + ')');
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].comment.length > 0 ) thyroidComment.push(thyroid[2].data[isthmusNoduleNum[isthmusN]].comment);
                    if (thyroid[2].data[isthmusNoduleNum[isthmusN]].note.length > 0 ) thyroidRecommendation.push(thyroid[2].data[isthmusNoduleNum[isthmusN]].note);
                    
                    if(thyroid[2].data[isthmusNoduleNum[isthmusN]].diameter[3]) {
                        isthmusLobeResult[isthmusN] = {result:(thyroidResult[2].lobe[isthmusNoduleNum[isthmusN]] + ', ' + thyroid[2].data[isthmusNoduleNum[isthmusN]].location.position + ', ' + thyroid[2].data[isthmusNoduleNum[isthmusN]].diameter[3] + thyroid[2].data[isthmusNoduleNum[isthmusN]].diameter[5] + entireCalcification.isthmus[isthmusN] + sizeChangeVal + ' ' + getRiskOfMalignancy(2, isthmusNoduleNum[isthmusN])), tirads: getRiskOfMalignancy(2, isthmusNoduleNum[isthmusN]), sizeCM:thyroid[2].data[isthmusNoduleNum[isthmusN]].diameter[3]};
                        isthmusLobeResult[isthmusN].result = isthmusLobeResult[isthmusN].result.replace(/,\s*$/, "");

                        if (orientationVal || marginVal || calcificationVal) {
                            if(isthmusN > 0) result += "<br/>";
                            result += thyroidResult[2].lobe[isthmusNoduleNum[isthmusN]] + ':' + getLocation(2, isthmusNoduleNum[isthmusN]) + thyroid[2].data[isthmusNoduleNum[isthmusN]].diameter[3] + thyroid[2].data[isthmusNoduleNum[isthmusN]].diameter[5] + sizeChangeVal + compositionVal + echogenicityVal  + orientationVal + marginVal + calcificationVal + spongiform + cometTailArtifact + entireCalcification.isthmus[isthmusN] + sizeChangeVal + extrathyroidalVal;
                        }
                        else{
                            if(isthmusN > 0) result += "<br/>";
                            result += thyroidResult[2].lobe[isthmusNoduleNum[isthmusN]] + ':' + getLocation(2, isthmusNoduleNum[isthmusN]) + thyroid[2].data[isthmusNoduleNum[isthmusN]].diameter[3] + thyroid[2].data[isthmusNoduleNum[isthmusN]].diameter[5] + compositionVal + echogenicityVal + spongiform + cometTailArtifact + entireCalcification.isthmus[isthmusN] + sizeChangeVal + extrathyroidalVal;
                        }

                        result = result.replace(/,\s*$/, "");
                        // if(entireCalcification.isthmus[isthmusN]) result += entireCalcification.isthmus[isthmusN];
                        if (extrathyroidalGross.length > 0) result += " (" + extrathyroidalGross.toString().split(',').join(", ") + ")";
    
                        result += " " + getRiskOfMalignancy(2, isthmusNoduleNum[isthmusN]);
    
                        if(thyroid[2].data[isthmusNoduleNum[isthmusN]].comment.length > 0) result += "<br/>" + thyroid[2].data[isthmusNoduleNum[isthmusN]].comment + ", isthums.";
                    }
                    else {if(thyroid[2].data[isthmusNoduleNum[isthmusN]].comment.length > 0)  result += thyroid[2].data[isthmusNoduleNum[isthmusN]].comment + ", isthums.";}
                }
            }
        }
        else{
            if(!thyroidClinic.normalThy) result += '<br/>3) Isthmus lobe<br/>No focal lesion'; 
        }

        // if (isthmusNoduleNum.length === 0) result += 'No focal lesion<br/>'; 

        if(cervical !== null){
            if(cervicNormal){
                if(thyroidClinic.normalThy) result += '<br/>' + nextNum + ". Cervical lymph node <br/>No pathologic lymph node in both necks.<br/>";
                else result += '<br/>' + nextNum + '. Cervical lymph node <br/>No pathologic lymph node in both necks.<br/>';
                nextNum += 1;
            }
            else{
                result += '<br/>' + nextNum + '. Cervical lymph node <br/>';
                nextNum += 1;

                for (nodeI = 0; nodeI < realNodeLength; nodeI++) {
                    if(cervical[nodeNum[nodeI]].note.length > 0 ) cervicalComment.push(cervical[nodeNum[nodeI]].note);
                    if(cervical[nodeNum[nodeI]].biopsy && cervical[nodeNum[nodeI]].FNA.checked){
                        if(biopsyFnaFlag) {
                            cervicalFnaBiopsyNodule.push('FNA');
                            biopsyFnaFlag = false;
                        }
                        cervicalFnaBiopsyNodule.push(cervical[nodeNum[nodeI]].location.position);
                        if(cervical[nodeNum[nodeI]].FNA.level1) cervicalFnaBiopsyNodule.push('level 1');
                        if(cervical[nodeNum[nodeI]].FNA.level2) cervicalFnaBiopsyNodule.push('level 2');
                        if(cervical[nodeNum[nodeI]].FNA.level3) cervicalFnaBiopsyNodule.push('level 3');
                        if(cervical[nodeNum[nodeI]].FNA.level4) cervicalFnaBiopsyNodule.push('level 4');
                        if(cervical[nodeNum[nodeI]].FNA.level5) cervicalFnaBiopsyNodule.push('level 5');
                        if(cervical[nodeNum[nodeI]].FNA.level6) cervicalFnaBiopsyNodule.push('level 6');
                        if(cervical[nodeNum[nodeI]].FNA.level7) cervicalFnaBiopsyNodule.push('level 7');
                        if(cervical[nodeNum[nodeI]].complications.no) cervicalFnaBiopsyNodule.push('no complication');
                        if(cervical[nodeNum[nodeI]].complications.yes) {
                            if(cervical[nodeNum[nodeI]].complications.valueInput !== '') cervicalFnaBiopsyNodule.push('complication (' + cervical[nodeNum[nodeI]].complications.valueInput + ')');
                            else cervicalFnaBiopsyNodule.push('complication');

                        }
                    }
                    if(cervical[nodeNum[nodeI]].biopsy && cervical[nodeNum[nodeI]].CNB.checked){
                        if(biopsyCnbFlag) {
                            cervicalCnbBiopsyNodule.push('CNB');
                            biopsyCnbFlag = false;
                        }
                        cervicalCnbBiopsyNodule.push(cervical[nodeNum[nodeI]].location.position);
                        if(cervical[nodeNum[nodeI]].CNB.level1) cervicalCnbBiopsyNodule.push('level 1');
                        if(cervical[nodeNum[nodeI]].CNB.level2) cervicalCnbBiopsyNodule.push('level 2');
                        if(cervical[nodeNum[nodeI]].CNB.level3) cervicalCnbBiopsyNodule.push('level 3');
                        if(cervical[nodeNum[nodeI]].CNB.level4) cervicalCnbBiopsyNodule.push('level 4');
                        if(cervical[nodeNum[nodeI]].CNB.level5) cervicalCnbBiopsyNodule.push('level 5');
                        if(cervical[nodeNum[nodeI]].CNB.level6) cervicalCnbBiopsyNodule.push('level 6');
                        if(cervical[nodeNum[nodeI]].CNB.level7) cervicalCnbBiopsyNodule.push('level 7');
                        if(cervical[nodeNum[nodeI]].complications.no) cervicalCnbBiopsyNodule.push('no complication');
                        if(cervical[nodeNum[nodeI]].complications.yes) cervicalCnbBiopsyNodule.push('complication (' + cervical[nodeNum[nodeI]].complications.valueInput + ')');
                        
                    }
                    if(nodeNum[nodeI]%2 !== 0){
                        if (cervical[nodeNum[nodeI]].neckLevel.level1) {
                            if(cervical[nodeNum[nodeI]].location.position === 'Right') suspiciousRightNodeNum.push('1'); 
                            else if (cervical[nodeNum[nodeI]].location.position === 'Left') suspiciousLeftNodeNum.push('1'); 
                        }
                        if (cervical[nodeNum[nodeI]].neckLevel.level2) {
                            if(cervical[nodeNum[nodeI]].location.position === 'Right') suspiciousRightNodeNum.push('2'); 
                            else if (cervical[nodeNum[nodeI]].location.position === 'Left') suspiciousLeftNodeNum.push('2'); 
                        }
                        if (cervical[nodeNum[nodeI]].neckLevel.level3) {
                            if(cervical[nodeNum[nodeI]].location.position === 'Right') suspiciousRightNodeNum.push('3'); 
                            else if (cervical[nodeNum[nodeI]].location.position === 'Left') suspiciousLeftNodeNum.push('3'); 
                        }
                        if (cervical[nodeNum[nodeI]].neckLevel.level4) {
                            if(cervical[nodeNum[nodeI]].location.position === 'Right') suspiciousRightNodeNum.push('4'); 
                            else if (cervical[nodeNum[nodeI]].location.position === 'Left') suspiciousLeftNodeNum.push('4'); 
                        }
                        if (cervical[nodeNum[nodeI]].neckLevel.level5) {
                            if(cervical[nodeNum[nodeI]].location.position === 'Right') suspiciousRightNodeNum.push('5'); 
                            else if (cervical[nodeNum[nodeI]].location.position === 'Left') suspiciousLeftNodeNum.push('5'); 
                        }
                        if (cervical[nodeNum[nodeI]].neckLevel.level6) {
                            if(cervical[nodeNum[nodeI]].location.position === 'Right') suspiciousRightNodeNum.push('6'); 
                            else if (cervical[nodeNum[nodeI]].location.position === 'Left') suspiciousLeftNodeNum.push('6'); 
                        }
                        if (cervical[nodeNum[nodeI]].neckLevel.level7) {
                            if(cervical[nodeNum[nodeI]].location.position === 'Right') suspiciousRightNodeNum.push('7'); 
                            else if (cervical[nodeNum[nodeI]].location.position === 'Left') suspiciousLeftNodeNum.push('7'); 
                        }
                    }
                }

                subNumberAfter = 1;
                if(suspiciousRightNodeNum.length > 0 || suspiciousLeftNodeNum.length > 0) {
                    result +=  subNumberAfter + ') Suspicious lymph node: ';
                    subNumberAfter += 1;
                    if(suspiciousRightNodeNum.length > 0) result += 'Right level ' + suspiciousRightNodeNum.join(', ') + ' ';
                    if(suspiciousLeftNodeNum.length > 0) result += 'Left level ' + suspiciousLeftNodeNum.join(', ');
                    result += '<br/>'
                }

                for (nodeI = 0; nodeI < realNodeLength; nodeI++) {
                    if(nodeNum[nodeI]%2 === 0){
                        if (cervical[nodeNum[nodeI]].neckLevel.level1) {
                            if(cervical[nodeNum[nodeI]].location.position === 'Right') indeterminateRightNodeNum.push('1'); 
                            else if (cervical[nodeNum[nodeI]].location.position === 'Left') indeterminateLefttNodeNum.push('1'); 
                        }
                        if (cervical[nodeNum[nodeI]].neckLevel.level2) {
                            if(cervical[nodeNum[nodeI]].location.position === 'Right') indeterminateRightNodeNum.push('2'); 
                            else if (cervical[nodeNum[nodeI]].location.position === 'Left') indeterminateLefttNodeNum.push('2'); 
                        }
                        if (cervical[nodeNum[nodeI]].neckLevel.level3) {
                            if(cervical[nodeNum[nodeI]].location.position === 'Right') indeterminateRightNodeNum.push('3'); 
                            else if (cervical[nodeNum[nodeI]].location.position === 'Left') indeterminateLefttNodeNum.push('3'); 
                        }
                        if (cervical[nodeNum[nodeI]].neckLevel.level4) {
                            if(cervical[nodeNum[nodeI]].location.position === 'Right') indeterminateRightNodeNum.push('4'); 
                            else if (cervical[nodeNum[nodeI]].location.position === 'Left') indeterminateLefttNodeNum.push('4'); 
                        }
                        if (cervical[nodeNum[nodeI]].neckLevel.level5) {
                            if(cervical[nodeNum[nodeI]].location.position === 'Right') indeterminateRightNodeNum.push('5'); 
                            else if (cervical[nodeNum[nodeI]].location.position === 'Left') indeterminateLefttNodeNum.push('5'); 
                        }
                        if (cervical[nodeNum[nodeI]].neckLevel.level6) {
                            if(cervical[nodeNum[nodeI]].location.position === 'Right') indeterminateRightNodeNum.push('6'); 
                            else if (cervical[nodeNum[nodeI]].location.position === 'Left') indeterminateLefttNodeNum.push('6'); 
                        }
                        if (cervical[nodeNum[nodeI]].neckLevel.level7) {
                            if(cervical[nodeNum[nodeI]].location.position === 'Right') indeterminateRightNodeNum.push('7'); 
                            else if (cervical[nodeNum[nodeI]].location.position === 'Left') indeterminateLefttNodeNum.push('7'); 
                        }
                    }
                }

                if(indeterminateRightNodeNum.length > 0 || indeterminateLefttNodeNum.length > 0) {
                    result +=  subNumberAfter + ') Indeterminate lymph node: ';
                    subNumberAfter +=1 ;
                    if(indeterminateRightNodeNum.length > 0) result += 'Right level ' + indeterminateRightNodeNum.join(', ') + ' ';
                    if(indeterminateLefttNodeNum.length > 0) result += 'Left level ' + indeterminateLefttNodeNum.join(', ');
                    result += '<br/>';
                }

                // var flagLateral = false;
                // var flagCenteral = false;

                // for (nodeI = 0; nodeI < realNodeLength; nodeI++) {
                    // var flag = false;

                    // if(cervical[nodeNum[nodeI]].location.neck === 'Lateral' && !flagLateral){
                    //     result += 'Lateral neck: ';
                    //     flagLateral = true;
                    // }
                    // if(cervical[nodeNum[nodeI]].location.neck === 'Centeral' && !flagCenteral){ 
                    //     result += 'Centeral neck: ';
                    //     flagCenteral = true;
                    // }

                    // if (nodeNum[nodeI]%2 === 0) result += ' Indeterminate, '; else result += ' Suspicious, '; 

                    // result += cervical[nodeNum[nodeI]].location.position + ' '; //+ ' level '; 
                    
                    // if(cervical[nodeNum[nodeI]].location.position === 'Right') {
                    //     rightNodeNum.push(nodeNum[nodeI]);
                    //     lymphResult.node[nodeNum[nodeI]] = 'Right ';//+ rightNodeNum.length;
                    // }
                    // else if(cervical[nodeNum[nodeI]].location.position === 'Left') {
                    //     leftNodeNum.push(nodeNum[nodeI]);
                    //     lymphResult.node[nodeNum[nodeI]] = 'Left ';//+ leftNodeNum.length;
                    // }

                    // if(cervical[nodeNum[nodeI]].FNA.level1) lymphResult.node[nodeNum[nodeI]] += '1 ';
                    // if(cervical[nodeNum[nodeI]].FNA.level2) lymphResult.node[nodeNum[nodeI]] += '2 ';
                    // if(cervical[nodeNum[nodeI]].FNA.level3) lymphResult.node[nodeNum[nodeI]] += '3 ';
                    // if(cervical[nodeNum[nodeI]].FNA.level4) lymphResult.node[nodeNum[nodeI]] += '4 ';
                    // if(cervical[nodeNum[nodeI]].FNA.level5) lymphResult.node[nodeNum[nodeI]] += '5 ';
                    // if(cervical[nodeNum[nodeI]].FNA.level6) lymphResult.node[nodeNum[nodeI]] += '6 ';
                    // if(cervical[nodeNum[nodeI]].FNA.level7) lymphResult.node[nodeNum[nodeI]] += '7 ';

                    // lymphResult.node[nodeNum[nodeI]] = lymphResult.node[nodeNum[nodeI]].replace(/ \s*$/, "");

                    // if (cervical[nodeNum[nodeI]].FNA.checked) lymphResult.fna[nodeNum[nodeI]] = 'FNA, '; else lymphResult.fna[nodeNum[nodeI]] = '';
                    // if (cervical[nodeNum[nodeI]].CNB.checked) lymphResult.cnb[nodeNum[nodeI]] = 'CNB, '; else lymphResult.cnb[nodeNum[nodeI]] = '';
                    
                    // if (cervical[nodeNum[nodeI]].complications.yes) lymphResult.complication[nodeNum[nodeI]] = 'complication <br/>';
                    // else lymphResult.complication[nodeNum[nodeI]] = 'no complication <br/>';

                    // if (cervical[nodeNum[nodeI]].neckLevel.level1) {result+= '1'; flag=true;}
                    // if (cervical[nodeNum[nodeI]].neckLevel.level2) {if(flag) {result+=', '} result+= '2'; flag = true;}
                    // if (cervical[nodeNum[nodeI]].neckLevel.level3) {if(flag) {result+=', '} result+= '3'; flag = true;}
                    // if (cervical[nodeNum[nodeI]].neckLevel.level4) {if(flag) {result+=', '} result+= '4'; flag = true;}
                    // if (cervical[nodeNum[nodeI]].neckLevel.level5) {if(flag) {result+=', '} result+= '5'; flag = true;}
                    // if (cervical[nodeNum[nodeI]].neckLevel.level6) {if(flag) {result+=', '} result+= '6'; flag = true;}
                    // if (cervical[nodeNum[nodeI]].neckLevel.level7) {if(flag) {result+=', '} result+= '7'; }

                    // // 0
                    // if(cervical[nodeNum[nodeI]].diameter[0] !== '' && cervical[nodeNum[nodeI]].diameter[1] === '') {
                    //     result += ' ( ' + cervical[nodeNum[nodeI]].diameter[0] + ' ~ ' + cervical[nodeNum[nodeI]].diameter[2] + ')<br/>';
                    // }

                    // // 1
                    // if(cervical[nodeNum[nodeI]].diameter[0] === '' && cervical[nodeNum[nodeI]].diameter[1] !== '') {
                    //     result += ' ( ~ ' + cervical[nodeNum[nodeI]].diameter[1] + ' ' + cervical[nodeNum[nodeI]].diameter[2]  + ')<br/>';
                    // }

                    // // 0, 1
                    // if(cervical[nodeNum[nodeI]].diameter[0] !== '' && cervical[nodeNum[nodeI]].diameter[1] !== '') {
                    //     if(cervical[nodeNum[nodeI]].diameter[2] === 'cm')
                    //         if(cervical[nodeNum[nodeI]].diameter[3] === 'cm')
                    //             result += ' (' + cervical[nodeNum[nodeI]].diameter[0] + ' ~ ' + cervical[nodeNum[nodeI]].diameter[1] + ' ' + cervical[nodeNum[nodeI]].diameter[2] + ')<br/>';
                    //         else
                    //             result += ' (' + cervical[nodeNum[nodeI]].diameter[0] + ' ~ ' + (cervical[nodeNum[nodeI]].diameter[1] * 0.1).toFixed(1) + ' ' + cervical[nodeNum[nodeI]].diameter[2] + ')<br/>';
                    //     else
                    //         if(cervical[nodeNum[nodeI]].diameter[3] === 'cm')
                    //             result += ' (' + (cervical[nodeNum[nodeI]].diameter[0] * 0.1).toFixed(1) + ' ~ ' + cervical[nodeNum[nodeI]].diameter[1] + ' ' + cervical[nodeNum[nodeI]].diameter[3] + ')<br/>';
                    //         else
                    //             result += ' (' + cervical[nodeNum[nodeI]].diameter[0] + ' ~ ' + cervical[nodeNum[nodeI]].diameter[1] + ' ' + cervical[nodeNum[nodeI]].diameter[2] + ')<br/>';
                    // }
                // }
            }
            if(extra === null) extra = '';
            if(extra) {  
                result += nextNum + '. Extrathyroidal lesion <br/>' + extra + '<br/>';
                nextNum += 1;
            }  
        }
        if(thyroidClinic.normalThy){
            result += '<br/>Conclusion:<br/>1. Normal thyroid gland (K-TIRADS 1) <br/>';
            numberAfter += 1;
            if(cervicNormal){
                result += '2. Normal cervical lymph nodes <br/>';
                numberAfter += 1;
            }
        }
        else {
            var tiradsArray = [];

            result += "<br/>Conclusion:<br/>";

            if(rightLobeResult[0].result !== ''){
                for (var rightL = 0; rightL < rightLobeResult.length; rightL++){
                    tiradsArray.push(rightLobeResult[rightL]);
                }
            }
            if(leftLobeResult[0].result !== ''){
                for (var leftL = 0; leftL < leftLobeResult.length; leftL++){
                    tiradsArray.push(leftLobeResult[leftL]);
                }
            }
            if(isthmusLobeResult[0].result !== ''){
                for (var isthmusL = 0; isthmusL < isthmusLobeResult.length; isthmusL++){
                    tiradsArray.push(isthmusLobeResult[isthmusL]);
                }
            }

            var sortResult = "";
            tiradsArray.sort(function(a, b) { 
                sortResult = a.tirads.localeCompare(b.tirads);
                if(a.tirads === b.tirads) sortResult = a.sizeCM.toString().localeCompare(b.sizeCM.toString());
                return sortResult;
            });
            tiradsArray = tiradsArray.reverse();

            var resultDiffuseFlag = true;
            var subNumberAfter = 1;
            var thyroidTitleFlag = true;
            
            if(thyroidClinic.diffusionThyroidDisease && resultDiffuseFlag) {
                result += numberAfter + ". Diffuse thyroid disease: Presence<br/>";
                resultDiffuseFlag = false;
                numberAfter += 1;
            };
            
            if(thyroidClinic.multinodule) {
                result += numberAfter + '. Multinodular goiter.<br/>';
                numberAfter += 1;
            }

            if(tiradsArray){
                for (var t2 = 0; t2 < tiradsArray.length; t2++){
                    // if(!thyroidClinic.diffusionThyroidDisease && resultDiffuseFlag){ 
                    //     result += numberAfter + ". Diffuse thyroid disease: Absence<br/>";
                    //     resultDiffuseFlag = false;                    
                    //     numberAfter += 1;
                    // }
                    if(thyroidTitleFlag){
                        result += numberAfter + ". Thyroid<br/>";
                        thyroidTitleFlag = false;
                        numberAfter += 1;
                    }
                    result += subNumberAfter + ') ' + tiradsArray[t2].result + "<br/>";
                    subNumberAfter += 1;
                }
            }
            if(cervicNormal){
                result += numberAfter + '. Normal cervical lymph nodes <br/>';
                numberAfter += 1;
            }
        }

        if(!cervicNormal){
            result += numberAfter + '. Cervical lymph node<br/>'
            numberAfter += 1;
            subNumberAfter = 1;
            if(suspiciousRightNodeNum.length > 0 || suspiciousLeftNodeNum.length > 0) {
                result +=  subNumberAfter + ') Suspicious lymph node: '
                subNumberAfter += 1;
                if(suspiciousRightNodeNum.length > 0) result += 'Right level ' + suspiciousRightNodeNum.join(', ') + ' ';
                if(suspiciousLeftNodeNum.length > 0) result += 'Left level ' + suspiciousLeftNodeNum.join(', ');
                result += '<br/>';
            }

            if(indeterminateRightNodeNum.length > 0 || indeterminateLefttNodeNum.length > 0) {
                result +=  subNumberAfter + ') Indeterminate lymph node: '
                subNumberAfter += 1;
                if(indeterminateRightNodeNum.length > 0) result += 'Right level ' + indeterminateRightNodeNum.join(', ') + ' ';
                if(indeterminateLefttNodeNum.length > 0) result += 'Left level ' + indeterminateLefttNodeNum.join(', ');
                result += ' <br/>';
            }
        }

        var tempFlag = true;
        subNumberAfter = 1;
        if(fnaBiopsyNodule.length > 0 || cnbBiopsyNodule.length > 0) {
            if(tempFlag){
                result += numberAfter + '. Biopsy<br/>'; 
                tempFlag = false;
                numberAfter += 1;
            }
            result += subNumberAfter + ') Thyroid<br/>';
            subNumberAfter += 1;
            if(fnaBiopsyNodule.length > 0) {
                result +=  'FNA, ' + fnaBiopsyNodule.join(', ') + '<br/>';
            }
            if(cnbBiopsyNodule.length > 0) {
                result += 'CNB, ' + cnbBiopsyNodule.join(', ') + '<br/>';
            }
        }

        console.log(cervicalCnbBiopsyNodule, cervicalFnaBiopsyNodule);
        if(cervicalCnbBiopsyNodule.length > 0 || cervicalFnaBiopsyNodule.length > 0) {
            if(tempFlag){
                result += numberAfter + '. Biopsy<br/>'; 
                tempFlag = false;
                numberAfter += 1;
            }
            result += subNumberAfter + ') Cervical lymph node<br/>';
            subNumberAfter += 1;
            tempFlag = false;
            if(cervicalFnaBiopsyNodule.length > 0){ 
                result += cervicalFnaBiopsyNodule.join(', ').replace('Right,', 'Right').replace('Left,', 'Left');
                tempFlag = true;
            }
            if(cervicalCnbBiopsyNodule.length > 0) {
                if(tempFlag) result += '<br/>';
                result += cervicalCnbBiopsyNodule.join(', ').replace('Right,', 'Right').replace('Left,', 'Left');
            }
            result += '<br/>';
        }

        // // FNA나 CNB체크가 되있는 노듈이나 노드가 없으면 결론에 나오지 않도록
        // for (nl = 0; nl < thyroid.length; nl++){
        //     for (noduleI = 0; noduleI < noduleNum[nl].length; noduleI++) {
        //         if(thyroidResult[nl].fna[noduleNum[nl][noduleI]] === 'FNA, ' || thyroidResult[nl].cnb[noduleNum[nl][noduleI]] === 'CNB, '){
        //             result +=  subNumberAfter + ') ' + thyroidResult[nl].fna[noduleNum[nl][noduleI]] + thyroidResult[nl].cnb[noduleNum[nl][noduleI]] + thyroidResult[nl].lobe[noduleNum[nl][noduleI]] + ', ' + thyroidResult[nl].complication[noduleNum[nl][noduleI]] + '<br/>';
        //             subNumberAfter += 1;
        //         }
        //     }
        // }

        // for (nodeI = 0; nodeI < realNodeLength; nodeI++) {
        //     if(lymphResult.fna[nodeNum[nodeI]] === 'FNA, ' || lymphResult.cnb[nodeNum[nodeI]] === 'CNB, '){
        //         result += subNumberAfter + ') ' + lymphResult.fna[nodeNum[nodeI]] + lymphResult.cnb[nodeNum[nodeI]] + lymphResult.node[nodeNum[nodeI]] + ', ' + lymphResult.complication[nodeNum[nodeI]];
        //         subNumberAfter += 1;
        //     }
        // }

        if(extra !== '') {
            result += numberAfter + '. Extrathyroidal lesion<br/>' + extra + '<br/>';
            numberAfter += 1;
        }

        /** Oct 17, 2023
         1. 현재 comment에 적힌 내용이 conclusion에 나오고 있는데 너무 적힌 내용들이 다양해서 conclusion에 구현이 되니 복잡하다는 의견이 있습니다. 
                이 부분은 추후에 릴리즈를 하고 나서 정리를 해야할 것 같은데 우선은 conclusion에는 comment가 없는 형태로 릴리즈하려고 합니다. * 
        */
        // if(thyroidComment.length > 0 || cervicalComment.length > 0) {
        //     result += numberAfter + '. Comment<br/>'
        //     numberAfter += 1;
        // }
        // subNumberAfter = 1;

        // if(thyroidComment.length > 0) {
        //     for (var i = 0; i < thyroidComment.length; i++)
        //     {
        //         result += subNumberAfter + ') Thyroid: ' + thyroidComment[i] + '<br/>';
        //         subNumberAfter += 1;
        //     }
        // }

        // if(cervicalComment.length > 0) {
        //     for (var i = 0; i < cervicalComment.length; i++)
        //     {
        //         result += subNumberAfter + ') Cervical lymph node: ' + cervicalComment[i] + '<br/>';
        //         subNumberAfter += 1;
        //     }
        // }
        /** 
         1. 현재 comment에 적힌 내용이 conclusion에 나오고 있는데 너무 적힌 내용들이 다양해서 conclusion에 구현이 되니 복잡하다는 의견이 있습니다. 
                이 부분은 추후에 릴리즈를 하고 나서 정리를 해야할 것 같은데 우선은 conclusion에는 comment가 없는 형태로 릴리즈하려고 합니다. * 
        */

        if(thyroidRecommendation.length > 0) {
            result += numberAfter + '. Recommendation<br/>'
            numberAfter += 1;
        }
        subNumberAfter = 1;

        if(thyroidRecommendation.length > 0) {
            for (var i = 0; i < thyroidRecommendation.length; i++)
            {
                result += subNumberAfter + ') ' + thyroidRecommendation[i] + '<br/>';
                subNumberAfter += 1;
            }
        }

        // // Thyroid에 Recommendation(판독문에 추가)가 있는 경우 conclusion 아래 문구 추가
        // for (nl = 0; nl < thyroid.length; nl++){
        //     for (noduleI = 0; noduleI < noduleNum[nl].length; noduleI++) {
        //         // console.log(thyroidResult[nl].recommendation[noduleNum[nl][noduleI]], nl, noduleI);
        //         if(thyroidResult[nl].recommendation[noduleNum[nl][noduleI]] !== '' && thyroidResult[nl].recommendation[noduleNum[nl][noduleI]] !== undefined){
        //             if(recommendationFalg) {
        //                 result +=  '<br/>Recommendation: <br/>';
        //                 recommendationFalg = false;
        //             }
        //             result += thyroidResult[nl].recommendation[noduleNum[nl][noduleI]] + '<br/>';
        //         }
        //     }
        // }

        if(thyroidClinic.addConclusion) result += `<div style="font-size:9px"><br/>* Malignancy risk stratification system: 2021 K-TIRADS (Korean Thyroid Imaging Reporting and Data System) (Korean J Radiol.2021;22:2094-2123) 
        <br/>K-TIRADS 1     No thyroid nodule 
        <br/>K-TIRADS 2     Benign (malignancy risk  &gt; 3%): iso-/hyperechoic spongiform nodule, partially cystic with echogenic foci and comet tail artifacts, pure cyst [Biopsy: Not indicated]
        <br/>K-TIRADS 3     Low suspicion (malignancy risk 3-10%): isoechoic or partially cystic nodules without suspicious US features. [Biopsy: &lt; 20 mm]
        <br/>K-TIRADS 4     Intermediate suspicion (malignancy risk 10-40%): solid hypoechoic nodule without suspicious US feature / isoechoic or partially cystic nodules with suspicious US features. Entirely calcified nodule. [Biopsy: &lt; 10-15 mm]
        <br/>K-TIRADS 5     High suspicion (malignancy risk &lt; 60%): solid hypoechoic nodule with suspicious US features. [Biopsy:&lt; 10 mm]
        <br/>[Biopsy for nodules is indicated regardless of nodule size if there is suspicion of metastasis (distant, lymph node), obvious gross ETE of trachea or recurrent laryngeal nerve, and clinical suspicion of medullary thyroid cancer]</div>`;
        setReport(result);
        setOpenRep(true);
    }

    const locationRecognizer = (index) => {
        if(index === 0) return 'R';
        else if (index === 1) return 'L';
        else return 'IS';
    }

    const cervicalLocationRecognizer = (index) => {
        if(index === 0) return 'lateral neck right indeterminate';
        else if (index === 1) return 'lateral neck right suspicious';
        else if (index === 2) return 'lateral neck left indeterminate';
        else if (index === 3) return 'lateral neck left suspicious';
        else if (index === 4) return 'centeral neck right indeterminate';
        else if (index === 5) return 'centeral neck right suspicious';
        else if (index === 6) return 'centeral neck left indeterminate';
        else return 'centeral neck left suspicious';
    }

    const handleClickOpenReport = () => {
        thyroid = JSON.parse(window.localStorage.getItem("nodule"));
        thyroidClinic = JSON.parse(window.localStorage.getItem("noduleClinic"));
        cervical = JSON.parse(window.localStorage.getItem("node"));
        cervicNormal = window.localStorage.getItem("nodeNormal") === 'true';
        extra = JSON.parse(window.localStorage.getItem("note"));
        
        // console.log('thyroid : ', thyroid);
        // console.log('thyroidClinic.normalThy :' , thyroidClinic.normalThy);
        // console.log('cervical : ', cervical);
        // console.log('cervicNormal : ' , cervicNormal);
        window.localStorage.getItem("nodeNormal")
        
        if(thyroid !== null) {
            if(!thyroidClinic.normalThy){ //&& !thyroid[0].diffusionThyroidDisease){
                for (var t = 0; t < thyroid.length; t++){
                    for (i = 0; i < thyroid[t].data.length; i++){
                        if (JSON.stringify(thyroid[t].data[i]) !== JSON.stringify(thyDefault[t].data[0]))
                        {                            
                            // console.log('realData ==> ', JSON.stringify(thyroid[t].data[i]));
                            // console.log('defaultData ==>', JSON.stringify(thyDefault[t].data[0]));
                            noduleNum[t].push(i);
                            if(thyroid[t].data[i].location.position === 'upper' || thyroid[t].data[i].location.position === 'middle' || thyroid[t].data[i].location.position === 'lower')
                            {
                                hasAllThyInfo[t].location[i] = true;
                            }
                            else{
                                missingValueIndex.thyroidLocation.push(locationRecognizer(t) + (i+1));
                                // console.log(missingValueIndex.thyroidLocation);
                                hasAllThyInfo[t].location[i] = false;
                            }
                            if(thyroid[t].data[i].diameter[3] !== ''){
                                hasAllThyInfo[t].diameter[i] = true;
                            }
                            else{
                                missingValueIndex.thyroidDiameter.push(locationRecognizer(t) + (i+1));
                                // console.log(missingValueIndex.thyroidDiameter);
                                hasAllThyInfo[t].diameter[i] = false;
                            }
                            if(thyroid[t].data[i].comment !== '') hasAllThyInfo[t].comment = true;
                        }
                        else{
                            hasAllThyInfo[t].location[i] = true;
                            hasAllThyInfo[t].diameter[i] = true;
                        }
                    }
                }

                for (var t2 = 0; t2 < thyroid.length; t2++){
                    for (var j = 0; j < thyroid.length; j++){
                        if(hasAllThyInfo[t2].location[j] !== undefined && hasAllThyInfo[t2].diameter[j] !== undefined){
                            if(hasAllThyInfo[t2].location[j] && hasAllThyInfo[t2].diameter[j]){
                                allThyHas = true;
                            }
                            else if(hasAllThyInfo[t2].comment) allThyHas = true;
                            else{
                                // console.log(t2, j, hasAllThyInfo[t2].location[j]);
                                allThyHas = false;
                                break;
                            }
                        }
                    }
                    if(!allThyHas) break;
                }
            }
            else{
                allThyHas = true;
            }
        }

        rightNoduleNum = noduleNum[0];
        leftNoduleNum = noduleNum[1];
        isthmusNoduleNum = noduleNum[2];

        if(cervical != null){
            if(!cervicNormal){
                for (var k =0; k < cervical.length; k++){
                    if (JSON.stringify(cervical[k]) !== JSON.stringify(cervicDefault)){
                        // if(cervical[0].location.neck !== ''){
                            // console.log(k + ': ' + JSON.stringify(cervical[k].diameter));
                            realNodeLength += 1;
                            nodeNum.push(k);
                            // console.log(cervical[k].diameter[0]);
                            if(cervical[k].diameter[0] || cervical[k].diameter[1])
                            {
                                hasAllCervicInfo.diameter[k] = true;
                            }
                            else{
                                hasAllCervicInfo.diameter[k] = false;
                                missingValueIndex.cervical.push(cervicalLocationRecognizer(k));
                            }
                            if(cervical[k].note.length > 0) hasAllCervicInfo.comment[k] = true;
                        // }
                    }
                    else{
                        hasAllCervicInfo.diameter[k] = true;
                        hasAllCervicInfo.comment[k] = true;
                    }
                }
                for (var m = 0; m < realNodeLength; m++){
                    if(hasAllCervicInfo.diameter[nodeNum[m]]) {
                        allCervicHas = true;
                        //break;
                    }
                    else if (hasAllCervicInfo.comment[nodeNum[m]]) allCervicHas = true;
                    else{
                        allCervicHas = false;
                        break;
                    }
                }
            }      
            else{
                allCervicHas = true;
            }
        }
        else{allCervicHas = true;}

        if(allThyHas && allCervicHas) getConclusion();
        else {
            setOpenAlert(true);
            if(!allThyHas && allCervicHas) {
                if(missingValueIndex.thyroidDiameter.length !== 0 && missingValueIndex.thyroidLocation.length !== 0) setErrorMsgThyroid("Thyroid: You must put values in location for " + missingValueIndex.thyroidLocation + " and diameter for " + missingValueIndex.thyroidDiameter + '.');
                else if(missingValueIndex.thyroidDiameter.length === 0) setErrorMsgThyroid("Thyroid: You must put values in location for " + missingValueIndex.thyroidLocation + ".");
                else setErrorMsgThyroid("Thyroid: You must put values in diameter for " + missingValueIndex.thyroidDiameter + ".");
            }
            else if(!allCervicHas && allThyHas) setErrorMsgCervical("Cervical Lymph: You must put values in diamter for all nodes.");
            else {
                if(missingValueIndex.thyroidDiameter.length !== 0 && missingValueIndex.thyroidLocation.length !== 0) {
                    setErrorMsgThyroid("1. Thyroid: You must put values in location for " + missingValueIndex.thyroidLocation + " and diameter for " + missingValueIndex.thyroidDiameter + ".");
                    setErrorMsgCervical("2. Cervical Lymph: You must put values in diamter for " + missingValueIndex.cervical + '.');
                }
                else if(missingValueIndex.thyroidDiameter.length === 0) {
                    setErrorMsgThyroid("1. Thyroid: You must put values in location for " + missingValueIndex.thyroidLocation + ".");
                    setErrorMsgCervical("2. Cervical Lymph:You must put values in diamter for " + missingValueIndex.cervical + '.');
                }
                else {
                    setErrorMsgThyroid("1. Thyroid: You must put values in diameter for " + missingValueIndex.thyroidDiameter + ".");
                    setErrorMsgCervical("2. Cervical Lymph:You must put values in diamter for " + missingValueIndex.cervical + '.');
                }
            }
        }
    }

    const handleClickCloseReport = () => {
        setOpenRep(false);
    }

    const handleClickOpenDelete = () => {
        setDeleteOpen(true);
    }

    const handleCloseDelete = () => {

        var cervical = JSON.parse(window.localStorage.getItem("node"));
        var extra = JSON.parse(window.localStorage.getItem("note"));

        var thyDefault = JSON.parse(window.localStorage.getItem("noduleDefault"));
        var thyClinicDefault = JSON.parse(window.localStorage.getItem("noduleClinicDefault"));
        var cervicDefault = JSON.parse(window.localStorage.getItem("nodeDefault"));

        var thyroid = thyDefault;
        var thyroidClinic = thyClinicDefault;

        window.localStorage.setItem("noduleNormal", true);
        window.localStorage.setItem("nodeNormal", true);
        window.localStorage.setItem("nodule", JSON.stringify(thyroid));
        window.localStorage.setItem("noduleClinic", JSON.stringify(thyroidClinic));
        window.localStorage.setItem("noduleClinicDefault", JSON.stringify(thyroidClinic));

        cervical = [cervicDefault];
        window.localStorage.setItem("node", JSON.stringify(cervical));

        extra = '';
        window.localStorage.setItem("note", JSON.stringify(extra));

        setDeleteOpen(false);
        window.location.reload();
    };

    const handleCloseDialog = () => {
        setDeleteOpen(false);
    };

  return (
    <div className={classes.root}>
        <Grid item sm={12} container justify="flex-end" style={{backgroundColor:'#E8E8E8'}}>
            <Button variant="contained" style={{backgroundColor:'#C71585', color:'white', marginRight:'20px', marginBottom:'10px', marginTop:'10px', zIndex:100}} 
            onClick={handleClickOpenDelete}>전체 초기화
            </Button>
            <Button variant="contained" style={{backgroundColor:'#2980B9', color:'white', marginRight:'20px', marginBottom:'10px', marginTop:'10px', zIndex:100}} 
            onClick={handleClickOpenReport}>판독문
            </Button>
        </Grid>
        <Dialog
            open={openAlert}
            onClose={handleClickCloseDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          > 
            <DialogTitle id="alert-dialog-title">{"Please check missing values."}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {errorMsgThyroid}<br/>{errorMsgCervical}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClickCloseDialog} color="primary" autoFocus>
                Close
              </Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={openCon}
            onClose={handleClickCloseDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth='true'
          > 
            {/* <DialogTitle id="alert-dialog-title">{"Conclusion"}</DialogTitle> */}
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <div dangerouslySetInnerHTML={{__html: report}} />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
                <CopyToClipboard text={report.split('<br/>').join('\n').replace('&gt;', '>').replace(/<[^>]+>/g, '').split('&lt;').join('<')} onCopy={onCopyText}>
                    <div className="copy-area">
                    <Button color="primary">Copy to Clipboard</Button>
                    <span className={`copy-feedback ${isCopied ? "active" : ""}`}/>
                    </div>
                </CopyToClipboard>
                <Button onClick={handleClickCloseDialog} color="primary" autoFocus>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
        <Dialog
            open={openRep}
            onClose={handleClickCloseReport}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth='true'
          > 
            {/* <DialogTitle id="alert-dialog-title">{"Conclusion"}</DialogTitle> */}
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <div dangerouslySetInnerHTML={{__html: report}} />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
                <CopyToClipboard text={report.split('<br/>').join('\n').replace('&gt;', '>').replace(/<[^>]+>/g, '').split('&lt;').join('<')} onCopy={onCopyText}>
                    <div className="copy-area">
                    <Button color="primary">Copy to Clipboard</Button>
                    <span className={`copy-feedback ${isCopied ? "active" : ""}`}/>
                    </div>
                </CopyToClipboard>
                <Button onClick={handleClickCloseReport} color="primary" autoFocus>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
        <Dialog
        open={openDelete}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Are you sure you want to delete all setting?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            If you agree to delete all setting, you cannot retrieve it. <br/>The settings for thyroid, cervical lymph node, and extrathyroidal Lesion will be deleted.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleCloseDialog} color="primary" autoFocus>
            Cancel
          </Button>
          <Button onClick={handleCloseDelete} color="primary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>    
  );
  }